import { render, staticRenderFns } from "./LoginCallbackView.vue?vue&type=template&id=2c19dac4"
import script from "./LoginCallbackView.vue?vue&type=script&lang=js"
export * from "./LoginCallbackView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports